const chalk = require("chalk");

exports.command = 'site <command>'
exports.desc = 'Manage site'
exports.builder = function (yargs) {

  const epilog = chalk.dim("Darwin Command Line Interface\nCopyright 2026 Darwin Inc. All Rights Reserved.\n")

  return yargs
    .commandDir('site_cmds')
    .help()
    .epilog(epilog)
}
exports.handler = function (argv) {}
